import { Footer } from '@/components/layout/footer'
import { PageShell } from '@/components/layout/PageShell'
import { PlayerCard } from '@/components/profile/PlayerCard'
import { ProfileTabs } from '@/components/profile/ProfileTabs'
import { ReferralPanel } from '@/components/profile/referral/ReferralPanel'
import { TransactionsPanel } from '@/components/profile/transactions/TransactionsPanel'
import { WalletConnectPanel } from '@/components/profile/WalletConnectPanel'
import { useRequireAuth } from '@/hooks/use-require-auth'
import { useAppSelector } from '@/store/hooks'
import { selectActiveProfileTab } from '@/store/slices/profileSlice'

export default function Profile() {
	const isAuthenticated = useRequireAuth()
	const activeTab = useAppSelector(selectActiveProfileTab)

	if (!isAuthenticated) {
		return null
	}

	return (
		<PageShell size='narrow' footer={<Footer />}>
			<PlayerCard />
			<ProfileTabs />

			{activeTab === 'balances' && <WalletConnectPanel />}
			{activeTab === 'referral' && <ReferralPanel />}
			{activeTab === 'transactions' && <TransactionsPanel />}
		</PageShell>
	)
}
